import { connect } from 'react-redux';
import { StoreState } from '../../../reducers';

import ButtonDuplicateSpread from '../../../components/Editor/ButtonDuplicateSpread';

const mapStateToProps = (state: StoreState) => {
	const {
		editor: {
			pagesSelection: { spreadIndices },
		},
	} = state;

	return {
		isDisabled: spreadIndices.length > 1,
	};
};

export default connect(mapStateToProps)(ButtonDuplicateSpread);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/ButtonDuplicateSpread/index.tsx